export function dateBdFormat(date) {
  if (date !== null) {
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    let year = date.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
}

export function timeBdFormat(date) {
  if (date !== null) return `${date.getHours()}.${date.getMinutes()}`;
}

export function dateQueryFormatReverse(date) {
  if (date !== null && date !== '') {
    let splitted = date.split('-');
    return `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
  }
}

export function dateQueryFormat(date) {
  if (date !== null)
    return `${date.getDate() + 1}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function dateFormatDay(date) {
  if (date !== null) {
    const yyyy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return dd + '/' + mm + '/' + yyyy;
  }
}

export function dateBdToDate(date, time) {
  if (time !== undefined && String(time).split('.').length === 1) {
    time = `${String(time)}.0`;
  }
  return date !== '' && time !== undefined
    ? new Date(`${date} ${String(time).replace('.', ':')}`)
    : null;
}

export function documentUrlParameters(
  documentUrlParameters,
  arrayFormatterSelectedValues
) {
  let copiedArrayFormatterSelectedValues = { ...arrayFormatterSelectedValues };
  let newDocumentUrlParameters = documentUrlParameters.filter(item => arrayFormatterSelectedValues[item.key]).map((item) => {
    if (arrayFormatterSelectedValues[item.key]?.includes('-') && item.key !== "mf_format") {
      let splitedDate = arrayFormatterSelectedValues[item.key].split('-');
      copiedArrayFormatterSelectedValues[
        item.key
      ] = `${splitedDate[2]}/${splitedDate[1]}/${splitedDate[0]}`;
    }
    return { [item.uri]: copiedArrayFormatterSelectedValues[item.key] };
  });
  return newDocumentUrlParameters
    .map((item) =>
      Object.values(item)[0] !== '' &&
        Object.values(item)[0] !== undefined &&
        Object.values(item)[0] !== null
        ? `${Object.keys(item)[0]}=${Object.values(item)[0]}&`
        : undefined
    )
    .join('');
}

export function addDays(date, days) {
  if (date !== undefined) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  return null;
}

export function dateTextFormat(date) {
  if (date)
    return `${date.getDay()} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
}